import React, { InputHTMLAttributes } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  showPasswordToggle?: boolean;
  isPasswordVisible?: boolean;
  onTogglePassword?: () => void;
  icon?: React.ReactNode;
}

export const InputField: React.FC<InputFieldProps> = ({
  label,
  error,
  className = '',
  showPasswordToggle = false,
  isPasswordVisible = false,
  onTogglePassword,
  icon,
  ...props
}) => {
  const isPassword = props.type === 'password';

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={props.id} className="block text-sm font-medium text-gray-300 mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          {...props}
          className={`w-full bg-[#1D1D1D] text-gray-200 rounded-[8px] border border-[#292929] px-4 py-2 
            focus:outline-none focus:border-[#00FF84] focus:ring-1 focus:ring-[#00FF84] 
            disabled:opacity-60 disabled:cursor-not-allowed
            ${(showPasswordToggle || icon) ? 'pr-10' : ''}
            ${error ? 'border-red-500' : ''}
            ${className}`}
          type={isPassword && isPasswordVisible ? 'text' : props.type}
        />
        {showPasswordToggle && isPassword && (
          <button
            type="button"
            onClick={onTogglePassword}
            className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-gray-300"
          >
            {isPasswordVisible ? (
              <EyeSlashIcon className="h-4 w-4" />
            ) : (
              <EyeIcon className="h-4 w-4" />
            )}
          </button>
        )}
        {icon && !showPasswordToggle && (
          <div className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400">
            {icon}
          </div>
        )}
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
}; 